function setRecentlyViewedProducts(productData) {
  const numberOfProducts = 6;
  let productList = [];
  const localData = localStorage.getItem('recentlyViewedProduct');

  if (!localData) {
    productList.push(productData);
    localStorage.setItem('recentlyViewedProduct', JSON.stringify(productList));
    return;
  }
  productList = JSON.parse(localData);
  productList = productList.filter((item) => item.productTitle !== productData.productTitle);
  productList.unshift(productData);

  if (productList.length > numberOfProducts) {
    productList = productList.slice(0, numberOfProducts);
  }

  localStorage.setItem('recentlyViewedProduct', JSON.stringify(productList));
}
